import React, { useState, useEffect } from 'react'
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Formik, Field, Form } from 'formik'
import { API_HOST } from '../lib/xhr'
import { map_panel } from '../components/panel'
import Navigation from '../components/Navigation'

const ProductView = ({ model, product, menu_state }) => {
  const [selected_item, set_selected_item] = useState(null)
  const [selected_qty, set_selected_qty] = useState(1)

  const panels = model ? model.panels : []
  const panel = model ? model.panel : null
  const items = product && product.products_items.length ? product.products_items : []
  const default_opts = items.length === 1 ? [] : [<option key="opt-default" value="">Choose...</option>]
  const item_options = items.length ? default_opts.concat(items.map((item, key) => {
    return <option key={'opt-' + key} value={item.SKU}>{item.Item}</option>
  })) : []
  const category = product && product.categories.length ? product.categories[0] : product && !product.categories.length ? { name: "Uncategorized" } : { name: "" }
  const product_image = getImage(product.Photo[0].localFile)

  useEffect(() => {
    set_selected_item(items.length === 1 ? items[0] : null)
  }, [items.length])

  return (
    <div id="product-view" className="view">
      <header className="" style={{ minHeight: 0 }}>
        <div className={menu_state}>
          <div className="py-2 bg-darkazul bg-opacity-80 text-white text-xl">
            <Navigation link_cls="hover:text-ice font-medium" />
          </div>
        </div>
        <div className="container pb-0 lg:pb-8 px-4 lg:px-0">
          &nbsp;
        </div>
        <div className="container px-4 py-4 lg:px-0">
          <div className="flex text-texgray font-bold uppercase">
            <div className="w-full md:w-2/3">
              <Link to="/#shop" onClick={e => {
                localStorage.setItem('category', category.name)
              }}>{category.name}</Link> / <span dangerouslySetInnerHTML={{ __html: product ? `${product.Brand} ${product.Name}` : '' }}></span>
            </div>
            <h1 className="hidden md:block w-full md:w-1/3">
              {category.name}
            </h1>
          </div>
        </div>
      </header>
      <main id="product" className="text-gray-500">
        <div className="container text-texgray px-4 pb-12 lg:px-0">
          {
            product ?
            <div className="no-flex lg:flex">
              <div className="flex items-start justify-center w-full lg:w-2/3 p-12">
                <GatsbyImage className="object-contain" image={product_image} alt={product.Photo[0].name} />
              </div>
              <div className="w-full lg:w-1/3">
                <div className="text-darkazul font-bold text-3xl pb-6">
                  <span dangerouslySetInnerHTML={{ __html: product.Brand }}></span> <span className="font-normal">{product.Name}</span>
                </div>
                <div className="text-3xl font-light pb-6 hidden">
                  ${selected_item ? (selected_item.Price * selected_qty).toLocaleString('en-US') : '0.00'}
                </div>
                <div className="pb-6 hidden">
                  <Formik
                    initialValues={{
                      items: '',
                      qty: selected_qty,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      // setSubmitting(post_form(values))
                      // scroll_top()
                    }}
                  >
                    {({ isSubmitting, setFieldTouched, setFieldValue, errors, values }) => {
                      const default_btn_class = "w-full btn btn-primary"
                      const btn_class = isSubmitting ? (default_btn_class + " disabled") : default_btn_class
                      return (
                        <Form>
                          {
                            isSubmitting ?
                            <div className="border px-4 py-3 mb-6 rounded" role="alert">
                              <span className="block sm:inline">Thanks! Check your e-mail soon!</span>
                            </div>
                            : null
                          }
                          <div className="">
                            <div className="w-full md:items-center mb-6 mr-6">
                              <div className="w-full">
                                <label className="block uppercase mb-1 pr-4" htmlFor="field-item">
                                  Item
                                </label>
                              </div>
                              <div className="w-full">
                                <Field className="input-field" id="field-item" name="item" children={item_options} as="select" onClick={e => {
                                  const item = items.find(item => (
                                    item.SKU === e.target.value
                                  ))
                                  set_selected_item(item)
                                }} disabled={items.length === 1} required />
                              </div>
                            </div>
                            <div className="w-full md:items-center mb-6">
                              <div className="w-full">
                                <label className="block uppercase mb-1 pr-4" htmlFor="field-qty">
                                  Quantity
                                </label>
                              </div>
                              <div className="flex">
                                <div className="w-20 mr-6">
                                  <Field className="input-field" id="field-qty" name="qty" type="number" onChange={e => {
                                    set_selected_qty(e.target.value)
                                    setFieldTouched('qty', true)
                                    return setFieldValue('qty', e.target.value)
                                  }} required />
                                </div>
                                <div className="flex-grow">
                                  <button className={default_btn_class} type="button">
                                    Add To Cart
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="w-full md:items-center">
                            <div className="w-full">
                              <button className={btn_class} type="submit" disabled={isSubmitting}>
                                Buy It Now
                              </button>
                            </div>
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
                <div className="py-6">
                  <h2 className="text-3xl font-bold text-darkazul">Product<br /><span className="font-normal">Specifications</span></h2>
                </div>
                <div className="text-2xl font-light pb-4">
                  {product.Description.split("\n").map((s, key) => {
                    return <div className="pb-2" key={'rtf-' + key}>{s}</div>
                  })}
                </div>
                <div className="pb-6">
                  <small>* Available at quantity minimums. * Images for reference only actual product may differ.</small>
                </div>
                {
                  product.sellsheet ?
                  <div className="pb-6">
                    <h2 className="font-bold text-darkazul hover:underline">
                      <a href={API_HOST + product.sellsheet.url} target="_blank" rel="noreferrer">Download <span className="font-normal">Sellsheet PDF</span></a>
                    </h2>
                  </div>
                  : null
                }
              </div>
            </div>
            : null
          }
        </div>
        {
          panels.length ?
          panels.map(map_panel)
          : null
        }
        {
          panel ?
          map_panel(panel, "")
          : null
        }
      </main>
    </div>
  )
}

export default ProductView
